export enum ChangelogItemTypeEnum {
  FEATURE = -1,
  IMPROVEMENT = -2,
  BUGFIX = -3,
  DATA = -4,
}
